export default __webpack_public_path__ + "static/media/Wealth.61c919b5.jpg";